let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dpvMR")).then(() => parcelRequire('eU6fa'));